import { render, staticRenderFns } from "./PetAndProjectHistoriesTabComponent.vue?vue&type=template&id=07201da8&scoped=true&"
import script from "./PetAndProjectHistoriesTabComponent.vue?vue&type=script&lang=js&"
export * from "./PetAndProjectHistoriesTabComponent.vue?vue&type=script&lang=js&"
import style0 from "./PetAndProjectHistoriesTabComponent.vue?vue&type=style&index=0&id=07201da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07201da8",
  null
  
)

export default component.exports